import Vue from 'vue';
import DsCard from '@/design-system/card/DsCard.vue';
import DsCardActions from '@/design-system/card/DsCardActions.vue';
import DsCardTitle from '@/design-system/card/DsCardTitle.vue';
import DsDialog from '@/design-system/dialog/DsDialog.vue';
import DsHeading from '@/design-system/text/DsHeading.vue';
import DsText from '@/design-system/text/DsText.vue';
import DsButton from '@/design-system/button/DsButton.vue';
import DsAlert from '@/design-system/alert/DsAlert.vue';

/**
 * Install design system components globally, so they can be used without being imported.
 */
Vue.component(DsCard.name, DsCard);
Vue.component(DsCardActions.name, DsCardActions);
Vue.component(DsCardTitle.name, DsCardTitle);
Vue.component(DsDialog.name, DsDialog);
Vue.component(DsHeading.name, DsHeading);
Vue.component(DsText.name, DsText);
Vue.component(DsButton.name, DsButton);
Vue.component(DsAlert.name, DsAlert);
